<template>
  <v-form v-on:submit.prevent="send" ref="form">
    <v-card-text>
      <v-row dense>
        <v-col cols="12">
          <div class="d-flex flex-column" style="height:50px;">
            <span>Il reste {{ smsLeft }} crédits (~{{
                this.leftSms(this.smsLeft)
              }} SMS vers la france). </span>
            <span v-if="smsLeftAfterSending != null">Après cet
            envoi il restera {{ smsLeftAfterSending }} crédits {{ leftNbSMS }}</span>
          </div>
        </v-col>
        <v-col cols="12">
          <v-textarea
              auto-grow
              solo
              v-model="sms.message"
              :rules="[...rules.nonEmpty(''), smsLeftAfterSending!=null ]"
              label="Message au clients"
              @blur="estimate"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="actions-btn">
      <v-spacer></v-spacer>
      <smart-btn primary type="submit" :disabled="!valid" :loading="isLoading">
        <v-icon small class="mr-1">send</v-icon>
        {{ $t("send") }}
      </smart-btn>
    </v-card-actions>
  </v-form>
</template>
<script>
import FormMixin from "../mixins/FormMixin";
import {get, post} from "@/utils/api";
import {EventBus} from "@/components/commons/event-bus";

export default {
  mixins: [FormMixin],
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
    message: {
      type: String,
      required: false,
      default: ''
    },
    list: {
      type: Array,
      required: false,
    },
    lead:{
      type:Object,
      required: false,
    }
  },
  data(self) {
    return {
      smsLeft: 0,
      smsLeftAfterSending: null,
      leftNbSMS: null,
      isLoading: false,
      sms: {message: self.message},
      smsFR: 4.5,
      smsRE: 13,
    };
  },
  created() {
    this.countSmsLeft().then(() => {
      if (this.sms.message !== "" && this.sms.message != null) {
        this.isLoading = true
        this.estimate()
      }
    });

  },

  watch: {},
  computed: {
    valid() {
      return this.smsLeftAfterSending >= 1 && this.sms.message.trim() !== "" && this.sms.message !== null
    }
  },
  methods: {
    leftSms(creditsNb){
      return Math.round(creditsNb / this.smsFR)
    },
    estimate() {
      let smsList = []
      if(this.list.length == 0){
        smsList = [{
          bookingId: null,
          siteId:null,
          message: this.sms.message,
          leadId: this.lead != null ? this.lead.id : null,
          virtualSite: this.lead != null ? this.lead.virtualSite : null
        }]
      } else {
        smsList = this.list.map((e) => {
          return {
            bookingId: e.id,
            siteId: e.siteId,
            message: this.sms.message,
            leadId: this.lead != null ? this.lead.id : null
          };
        });
      }


      post('/api/sms/estimate', smsList).json((r) => {
        this.smsLeftAfterSending = this.smsLeft - r
        this.leftNbSMS = `(soit ~${this.leftSms(this.smsLeftAfterSending)} SMS vers la france)`
        this.isLoading = false
      });
    },

    send() {
      if (this.smsLeftAfterSending < 0) {
        EventBus.$emit("toaster-msg", "Envoi annulé: Manque de crédits SMS");
      } else {
        if (this.valid && this.$refs.form.validate()) {
          this.$emit("send", this.sms);
          this.reset();
        }
      }
    },
    reset() {
      this.smsLeftAfterSending = null;
      this.sms = {
        message: ""
      };
    },
    countSmsLeft() {
      return get("/api/sms/left-credits").json((count) => {
        this.smsLeft = count
      });
    },
  },
};
</script>